import Vue from 'vue'
import copy from "@/utils/copy";

const Helpers = {}

Helpers.install = function (Vue) {
  Vue.prototype.$getBatteryMeta = function (cells) {
    const amps = [];
    const watts = [];
    const woas = [];
    const numbers = [];
    // console.log(cells);
    cells.map(function (v) {
      amps.push(v.value);
      watts.push(v.power);
      woas.push(v.pov);
      numbers.push(parseInt(v.number));
    });

    const batteryStrength = [
      {
        name: 'Value',
        max: Math.max(...amps),
        min: Math.min(...amps)
      },
      {
        name: 'Power',
        max: Math.max(...watts),
        min: Math.min(...watts)
      },
      {
        name: 'Power / Value',
        max: Math.max(...woas),
        min: Math.min(...woas)
      }
    ];

    numbers.sort(function (a, b) {
      return a - b;
    });

    // console.log(result);
    return {
      batteryStrength: batteryStrength,
      sortedCells: numbers
    };

  }
  Vue.prototype.$clone = function (val) {
    return copy(val)
  }
  Vue.prototype.between = function(number, a, b) {
    const min = Math.min(a, b),
      max = Math.max(a, b);

    return number > min && number < max;
  };
}

export default Helpers;
Vue.use(Helpers);
